import { useEffect, useState } from "react";

import styles from "./styles/Dashboard.module.scss";

import { Col, Row } from "react-bootstrap";
import { SubTitle } from "../../Components/CustomComponents";
// import MatchCard from '../../Components/Cards/MatchCard';
// import TournamentCard from '../../Components/Cards/TournamentCard';
import { BiSolidBadgeDollar } from "react-icons/bi";
import { FaUserNurse } from "react-icons/fa6";
import { GiGamepadCross } from "react-icons/gi";
import { IoLogoGameControllerB } from "react-icons/io";
import DashboardCard from "../../Components/Cards/DashboardCard";
import ThemeChart from "../../Components/ThemeChart";
import { chartData, chartOptions, chartOptionsOrder } from "../../constants";
import { useGetDashboardDetailsQuery } from "../../Data/services/dashboardApi";
import { ROUTES } from "./constants";

export default function Dashboard({ setPage }) {
  let bg1 = "#6457c6";
  let bg2 = "#6457c6";
  let iconColor = "#6457c6";

  const {
    data: dashboardData,
    isSuccess,
    isLoading,
    isFetching,
    refetch,
  } = useGetDashboardDetailsQuery();
  // console.log(dashboardData);

  const [updatedData, setUpdatedData] = useState([]);
  const [updatedOrderData, setUpdatedOrderData] = useState([]);

  const getMonthName = (monthString) => {
    const [year, month] = monthString.split("-").map(Number); // Extract year and month
    const date = new Date(year, month - 1); // Correctly set year and 0-indexed month
    return date.toLocaleString("default", { month: "short" }); // Get short month name
  };
  // MARK: Dummy Data

  useEffect(() => {
    const updatedData = [];
    chartData.labels.forEach((month) => {
      const dataForMonth =
        dashboardData?.data?.dashboardGraphData?.totalEarningGraph?.find(
          (item) => getMonthName(item.month) === month
        );
      updatedData.push(dataForMonth ? dataForMonth.total_earnings : 0);
    });
    setUpdatedData(updatedData);
  }, [chartData.labels, dashboardData]);

  useEffect(() => {
    const updatedData = [];
    chartData.labels.forEach((month) => {
      const dataForMonth =
        dashboardData?.data?.dashboardGraphData?.totalOrderGraph?.find(
          (item) => getMonthName(item.month) === month
        );
      updatedData.push(dataForMonth ? dataForMonth.total_orders : 0);
    });
    setUpdatedOrderData(updatedData);
  }, [chartData.labels, dashboardData]);

  const handleViewLiveMatches = () => {
    setPage(ROUTES.LIVE_MATCHES);
  };

  const handleViewTournament = () => {
    setPage(ROUTES.TOURNAMENTS);
  };

  const cardData = [
    {
      icon: <FaUserNurse color={iconColor} />,
      number:
        dashboardData?.data == null
          ? 0
          : dashboardData?.data?.dashboardStats?.total_users,
      text: "Total Users",
      lg: 6,
    },
    {
      icon: <IoLogoGameControllerB color={iconColor} />,
      number:
        dashboardData?.data == null
          ? 0
          : dashboardData?.data?.dashboardStats?.total_shops,
      text: "Total Shops",
      lg: 6,
    },
    {
      icon: <GiGamepadCross color={iconColor} />,
      number:
        dashboardData?.data == null
          ? 0
          : dashboardData?.data?.dashboardStats?.total_completed_orders,
      text: "Total Completed Orders",
      lg: 6,
    },
    {
      icon: <BiSolidBadgeDollar color={iconColor} />,
      number:
        dashboardData?.data == null
          ? 0
          : dashboardData?.data?.dashboardStats?.total_earnings,
      text: "Total Earnings",
      lg: 6,
    },
  ];

  return (
    <div className={styles.Dashboard}>
      <div className={styles.headerContainer}>
        <div className={styles.titleContainer}>
          <SubTitle text={"Dashboard"} />
        </div>
      </div>
      <Row className={`${styles.matchRow} w-100 mt-2 mb-5`}>
        {cardData.map((card, index) => (
          <Col
            key={index}
            className="mt-2 mb-2"
            lg={card?.lg}
            md={card?.lg}
            sm={6}
          >
            <DashboardCard
              // loading={isFetching}
              bg1={bg1}
              bg2={bg2}
              icon={card.icon}
              number={card.number ?? 100}
              text={card.text}
            />
          </Col>
        ))}
      </Row>

      <Row className="">
        <Col md={6} sm={12}>
          <div className={"themeChart"}>
            <ThemeChart
              type="line"
              data={updatedData}
              chartOptions={chartOptions}
              loading={isLoading}
            />
          </div>
        </Col>
        <Col md={6} sm={12}>
          <div className={"themeChart"}>
            <ThemeChart
              type="line"
              data={updatedOrderData}
              chartOptions={chartOptionsOrder}
              loading={isLoading}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
